import BaseQuestionModel from '../BaseQuestionModel'
import { IQuestionModelConstructor, QuestionType } from '../types'
import {
  ImpressionDialQuestionModelTypes,
  IImpressionDialQuestionModelState,
  IImpressionDialResponseValidation
} from './types'

const ImpressionDialQuestionModel: IQuestionModelConstructor<ImpressionDialQuestionModelTypes> = (
  questionSchema,
  action
) => {
  const { model } = BaseQuestionModel<ImpressionDialQuestionModelTypes, IImpressionDialQuestionModelState>({
    questionType: QuestionType.IMPRESSION_DIAL,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse,
    namedFrames: questionSchema.training && questionSchema.video ? ['training', 'question'] : ['question']
  })
  return model
}

function submitResponse({ response }: IImpressionDialQuestionModelState) {
  delete response.video_shown
  return [response]
}

function initState(state: IImpressionDialQuestionModelState): IImpressionDialQuestionModelState {
  // state.response = {}
  return state
}

function validateResponse({
  response,
  frame,
  questionSchema
}: IImpressionDialQuestionModelState): IImpressionDialResponseValidation {
  if (
    !questionSchema.video ||
    !questionSchema.matrix_batches?.length ||
    (questionSchema.training && !questionSchema.training_video)
  ) {
    return {
      valid: true
    }
  }

  return {
    valid:
      'training' == frame && questionSchema.training
        ? Boolean(response?.training_shown)
        : Boolean(response?.video_shown)
  }
}

export default ImpressionDialQuestionModel
